import SearchBox from "components/search-box";
import { FaAngleDown } from "react-icons/fa6";
import { Outlet } from "react-router-dom";
import ReactTooltip from "react-tooltip";

export default function InsideLayout() {
  return (
    <div className="relative">
      {/* Card widget */}
      <div className="header-back-gradient">
        <div className="container py-6">
          <div className="w-full px-5">
            <div className="flex w-full items-center ">
              <div className="w-full justify-between md:flex md:py-6">
                <p className="text-header relative mb-4 text-white md:mb-0">
                  Block Details
                </p>
                <SearchBox
                  className="sm:min-w-[480px] xl:min-w-[650px]"
                  placeholder="Search by Address/ Txn Hash/ Block/ Token/Domain Name"
                />
              </div>
            </div>
            <div className="mt-3 flex w-full text-center md:mt-1">
              <div className="ml-auto mr-auto flex gap-4 md:mr-0">
                <button className="btn btn-gray text-xsmall flex items-center !font-semibold">
                  Buy{" "}
                  <span className="ml-[1px] text-xs">
                    <FaAngleDown />
                  </span>
                </button>
                <button className="btn btn-gray text-xsmall flex items-center !font-semibold">
                  Exchange{" "}
                  <span className="ml-[1px] text-xs">
                    <FaAngleDown />
                  </span>
                </button>
                <button className="btn btn-gray text-xsmall flex items-center !font-semibold">
                  Play{" "}
                  <span className="ml-[1px] text-xs">
                    <FaAngleDown />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <Outlet />

        <ReactTooltip
          id="question-tip-block"
          place="right"
          effect="solid"
          class="custom-tooltip right"
        />
      </div>
    </div>
  );
}
